<script>
/*jshint esversion: 6 */
import { inject} from 'vue';
import { isFunction, isNil} from 'lodash';


export default {
    name: "ButtonGroup",
    props: {
		'hinted': {type:String},
        'disabled': {type: Boolean},
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
    },
    setup(props) {
        const buttonFunctionParent = inject('buttonFunctionParent');
        function buttonClick(getfunction) {
            var toParent = {
                'id': props.schemaId,
                'functionVal': getfunction.functionVal,
                'argumentsVal': getfunction.argumentsVal
            };
            if (buttonFunctionParent) {
                buttonFunctionParent(toParent);
            }
        }

        function visibility(id, index) {
            let field = props.schema.buttons[index];
            if (isFunction(field.visible)) return field.visible.call(this, this.model, field, this);
            if (isNil(field.visible)) return true;
            return field.visible;
        }
        return {
            buttonClick,
            visibility
        }
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .multiButton(
        :class="disabled === true ? 'fieldDisabled': ''"
    )
        label(v-if="schema.label && schema.label.length > 0" v-html="schema.label")
        div(
            :class="schema.class"
        )
            .row(:style="disabled === true ? 'cursor: not-allowed; opacity: 0.5': ''")
                template(v-for="item, index in schema.buttons")
                    .singleButton(
                        :class="schema.direction === 'horizontical' ? `col-${schema.cols}` : 'col-12'"
                        :style="item.disabled === true ? 'cursor: not-allowed; opacity: 0.5': ''"
                    )
                        button(
                            :class="item.class"
                            :style="[item.disabled === true ? 'pointer-events:none' : '', disabled === true ? 'pointer-events:none': '']" 
                            @click="buttonClick(item.onclick)" 
                            v-if="visibility(schemaId, index) === true" 
                        ) {{ item.label }}
                        .hint(v-if="item.hinted && item.hinted.length > 0" v-html="item.hinted") 
        .hint(v-if="hinted && hinted.length > 0" v-html="hinted") 
</template>